<template>
  <div class="main_div cmdp_admin">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">무인 보관함 현황</h1>
        <div style="text-align:right; font-size:23px; float:right; line-height: 42px;">
          <button class="large_btn orange" style="width:100px; float:right; margin-left:10px;"
                  @click="onClickRefresh"
          > 새로고침
          </button>
          {{ lastRenderingTime }}
          <kendo-switch
              ref="autoYnRef"
              :messages-checked="'자동'"
              :messages-unchecked="'수동'"
              :checked="autoRender"
              @change="setAutoRender">
          </kendo-switch>
        </div>
      </div>
      <div class="contents_wrap">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="getLockerInfo">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanSearchDataEvent">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col3">
                <dd>
                  <label>사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="facilityListRef"
                          :data-source="facilityList"
                          :value="selectedFacility"
                          :data-text-field="'facilityNm'"
                          :data-value-field="'facility'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="onChangeFacility">
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>거점</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="areaListRef"
                          :data-text-field="'areaNm'"
                          :data-value-field="'area'"
                          :value="selectedArea"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="onChangeArea">
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>무인보관함</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="lockerIdRef"
                          :data-text-field="'lockerNm'"
                          :data-value-field="'lockerId'"
                          :value="selectedLocker"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="onChangeLocker">
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="tableList.length > 0" class="box_flex mgt20">
        <div class="w50">
          <div class="box_inventory_status_cound ai_box_bg">
            <ul>
              <li>
                <div class="color_info">
                  <div><span class="box_use"></span>사용중</div>
                  <div><span class="box_available"></span>사용가능</div>
                  <div><span class="box_select"></span>선택</div>
                  <div><span class="kiosk_send"> </span>발송</div>
                  <div><span class="kiosk_receipt"> </span>수신</div>
                </div>
              </li>
              <li>
                <div class="title">{{ mailBox.cellWidth }}*{{ mailBox.cellHeight }}</div>
                <div class="txt_info">등기함 별도</div>
              </li>
              <li v-for="cell in cellList">
                <div class="title">{{ cell.sizeNm }} {{ cell.cellWidth }}*{{ cell.cellHeight }}</div>
                <div class="txt_info">사용가능/전체</div>
                <div class="txt_count"><span class="big_num">{{ cell.avail }}</span>{{ cell.total }}</div>
              </li>
            </ul>
          </div>
          <div class="txt_r mgt10">
            <button v-show="showBtn && isSU" class="small_btn mr10" @click="openLocker">칸 열기</button>
            <span class="quantity_icon">N</span><b>동일 고객 다중 발송 건</b> : 수거 시 일괄수거 필요
          </div>
          <table id="locker" style="width:66%; margin-top:20px">
            <tbody>
            <tr v-for="trList in tableList">
              <td v-for="cell in trList"
                  :id="cell.lockerCellId"
                  :rowspan="cell.rowspan"
                  :colspan="cell.colspan"
                  :width="cell.cellWidth"
                  :class="{'kiosk_send' : cell.taskGbn === 'S', 'kiosk_receipt' : cell.taskGbn === 'R'}"
                  :style="`background-color: ${getBgColor(cell)}`"
                  @click="onClickCell(cell)">
                <div v-if="cell.taskCnt > 1" class="quantity f_r">{{ cell.taskCnt }}</div>
                <span v-if="cell.mailBoxYn === 'Y'">등기 우편함</span>
                <span v-else>{{ cell.originId }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="ai_box_bg">
          <div class="f_r mgt10">총 <span class="txt_blue">{{ taskList.length }}</span>건</div><h2 class="mgt10">무인 보관함 상세정보</h2>
          <ul v-if="taskList.length === 0" class="keep_info">
            <div class="txt_c">
              <img class="img_noproduct" src="@/assets/img/etners-web/img_receipt_complete_noproduct.png">
              <h3>등록된 물품이 없습니다.</h3>
            </div>
          </ul>
          <ul v-if="taskList.length > 0 && prevCell !== '' && (prevCell.taskGbn === 'S' || prevCell.mailBoxYn === 'Y')" class="keep_info">
            <li v-for="task in taskList" @click="onClickDetail(task)">
              <div class="left kiosk_send">
                <div>{{ task.sendScnNm }}</div>
                <div>발송</div>
                <div>발신자 : {{ task.sendNm }}</div>
                <div>{{ task.frstRgstDt }}</div>
              </div>
              <dl>
                <dt>부서</dt>
                <dd>{{ task.sendDept }}</dd>
                <dt>운송사</dt>
                <dd>{{ task.shpcScnNm }}</dd>
                <dt v-if="task.sendScn !== '01'">운송장번호</dt>
                <dd v-if="task.sendScn !== '01'">{{ task.blNo }} - 수량{{ task.qty }}</dd>
              </dl>
            </li>
          </ul>
          <ul v-if="prevCell.taskGbn === 'R'" class="keep_info">
            <li v-for="task in taskList" @click="onClickDetail(task)">
              <div class="left kiosk_receipt">
                <div>{{ task.receiveScnNm }}</div>
                <div>수령 <span v-if="task.days !== '0'" class="txt_day">+{{ task.days }}</span></div>
                <div>수신자 : {{ task.receiveNm}} </div>
                <div>{{ task.frstRgstDt }}</div>
              </div>
              <dl>
                <dt>부서</dt>
                <dd>{{ task.receiveDept }}</dd>
                <dt>취급구분</dt>
                <dd>{{ task.receiveScnNm }}</dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import ApiConfig from "@/api/api.config"
import ApiUtil from "@/api/api.util"
import EtnersParseUtil from "@/common/etners.parse.util"
import EtnersCommonUtil from "@/common/etners.common.util"

export default {
  name: 'LockerStatus',
  created() {
    const vm = this
    const jsonStrLastRouteParams = sessionStorage.getItem('LAST_ROUTE_PARAMS')
    vm.lastRouteParams = sessionStorage.getItem('LAST_ROUTE_NAME') === 'SendDetail' ? (jsonStrLastRouteParams === undefined ? [] : JSON.parse(jsonStrLastRouteParams)) : []
  },
  mounted () {
    const vm = this
    vm.firstAccess()
  },
  methods: {
    firstAccess(){
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/search`
      ApiUtil.get(url).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.facilityList = resultData.facilityList
        vm.areaMap = resultData.areaMap
        vm.lockerMap = resultData.lockerMap

        const notiParams = JSON.parse(sessionStorage.getItem('NOTI_PARAMS'))
        const routeName = sessionStorage.getItem('LAST_ROUTE_NAME')
        if ((!!notiParams && !!notiParams.facility) && routeName === 'null') {
          // 사업장
          vm.$refs.facilityListRef.kendoWidget().setDataSource(vm.facilityList)
          vm.selectedFacility = notiParams.facility
          // 거점
          vm.$refs.areaListRef.kendoWidget().setDataSource(vm.areaMap[vm.selectedFacility])
          vm.selectedArea = notiParams.area
          // 무인보관함
          vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`])
          vm.selectedLocker = notiParams.lockerId
          // 초기화
          sessionStorage.setItem('NOTI_PARAMS', '{}')
          vm.getLockerInfo()
          return
        } else {

          // 사업장
          vm.$refs.facilityListRef.kendoWidget().setDataSource(vm.facilityList)
          vm.selectedFacility = vm.loginUserData.facility
          if (vm.loginUserData.facility === null) {
            vm.selectedFacility = vm.facilityList[0].facility
          }
          // 거점
          vm.$refs.areaListRef.kendoWidget().setDataSource(vm.areaMap[vm.selectedFacility])
          vm.selectedArea = vm.loginUserData.area
          if (vm.loginUserData.area === null) {
            vm.selectedArea = vm.areaMap[vm.selectedFacility][0].area
          }
          // 무인보관함
          vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`])
          vm.selectedLocker = vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`][0].lockerId
          vm.getLockerInfo()
        }
      })
    },
    initData(){
      const vm = this
      vm.tableList = []
      vm.cellList = []
      vm.taskList = []
      vm.prevCell = ''
    },

    getLockerInfo(){
      const vm = this
      vm.initData()

      if(EtnersCommonUtil.isEmpty(vm.selectedFacility) || EtnersCommonUtil.isEmpty(vm.selectedArea)){
        return
      }
      if(vm.selectedFacility !== vm.selectedArea.substr(0,2)){
        return
      }
      const param = {
        loginUserToken: vm.loginUserToken,
        lockerId: vm.selectedLocker
      }
      ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerList.json`, param).then(res => {
        const resultData = res.data.resultData
        const messageCode = res.data.resultStatus.messageCode
        if(messageCode !== '2000'){
          return
        }
        if(EtnersCommonUtil.isEmpty(resultData.lockerInfoMap)){
          return
        }
        const keys = Object.keys(resultData.lockerInfoMap)
        vm.tableList = resultData.lockerInfoMap[keys[0]]
        vm.cellList = resultData.cellInfoMap[keys[0]]

        for(let i=0; i<vm.cellList.length; ++i){
          if(vm.cellList[i].mailBoxYn === 'Y'){
            vm.mailBox = vm.cellList[i]
            vm.cellList.splice(i,1)
          }
        }
      })
    },

    getBgColor(cell){
      const vm = this
      if(cell.cellStatus === '01'){
        return '#1592e6'
      }
      else {
        return '#B2B2B2'
      }
      // else if(cell.cellStatus === '02'){
      //   return '#B2B2B2'
      // }
      // else if(cell.cellStatus === '03'){
      //   return '#000000'
      // }
    },

    openLocker(){
      const vm = this
      kendo.confirm(`${vm.prevCell.originId}번 칸을 여시겠습니까?`).done(function(){
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/lockerMstOpen.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          lockerId: vm.selectedLocker,
          lockerCellInfoList: new Array(vm.prevCell)
        }
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('정상적으로 처리되지 않았습니다.')
            return
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            return
          }
          kendo.alert(`${vm.prevCell.originId}번 칸이 열렸습니다.`)
        })
      })
    },

    onClickCell(cell){
      const vm = this
      vm.taskList = []
      if(vm.prevCell !== ''){
        document.getElementById(vm.prevCell.lockerCellId).style.background=vm.getBgColor(vm.prevCell)
        if(vm.prevCell.taskGbn === 'S'){
          document.getElementById(vm.prevCell.lockerCellId).classList.add('kiosk_send')
        }
        else if(vm.prevCell.taskGbn === 'R'){
          document.getElementById(vm.prevCell.lockerCellId).classList.add('kiosk_receipt')
        }
      }

      if(vm.prevCell.lockerCellId === cell.lockerCellId){
        vm.prevCell = ''
        vm.showBtn = false
        return
      }

      document.getElementById(cell.lockerCellId).style.background='#fe5f40'
      document.getElementById(cell.lockerCellId).classList.remove('kiosk_send', 'kiosk_receipt')
      vm.prevCell = cell
      if(EtnersCommonUtil.isNotEmpty(vm.prevCell)){
        vm.showBtn = true
      }

      const taskGbn = cell.taskGbn
      const mailBoxYn = cell.mailBoxYn

      if(EtnersCommonUtil.isEmpty(taskGbn) && mailBoxYn === 'N'){
        return
      }

      const taskId = cell.taskId
      const lockerId = vm.$refs.lockerIdRef.kendoWidget().value()
      const param = {
        loginUserToken: vm.loginUserToken,
        lockerId: lockerId,
        taskGbn: taskGbn,
        taskId: taskId,
        mailBoxYn: mailBoxYn
      }

      ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/kiosk/locker/taskList.json`, param).then(res => {
        const resultData = res.data.resultData
        const messageCode = res.data.resultStatus.messageCode
        if(messageCode !== '2000'){
          return
        }
        vm.taskList = resultData
      })
    },

    setAutoRender() {
      const vm = this
      vm.autoRender = !vm.autoRender
      if (vm.autoRender) {
        vm.intervalSetting = window.setInterval(() => {
              vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(new Date())
            }, 300000
        )
      } else {
        window.clearInterval(vm.intervalSetting)
      }
    },

    onChangeFacility: function (e) {
      const vm = this
      vm.initData()
      vm.selectedFacility = vm.$refs.facilityListRef.kendoWidget().value()
      vm.$refs.areaListRef.kendoWidget().setDataSource(vm.areaMap[vm.selectedFacility])

      vm.selectedArea = vm.areaMap[vm.selectedFacility][0].area
      vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`])

      vm.selectedLocker = vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`][0].lockerId
      vm.getLockerInfo()
    },

    onChangeArea(){
      const vm = this
      vm.initData()
      vm.selectedArea = vm.$refs.areaListRef.kendoWidget().value()
      vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`])

      vm.selectedLocker = vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`][0].lockerId
      vm.getLockerInfo()
    },

    onChangeLocker(){
      const vm = this
      vm.initData()

      vm.selectedLocker = vm.$refs.lockerIdRef.kendoWidget().value()
      vm.getLockerInfo()
    },

    cleanSearchDataEvent: function (e) {
      const vm = this
      const refs = this.$refs

      if (refs.facilityListRef !== undefined) {
        vm.$refs.facilityListRef.kendoWidget().setDataSource(vm.facilityList)
        vm.selectedFacility = vm.loginUserData.facility
        if (vm.loginUserData.facility === null) {
          vm.selectedFacility = vm.facilityList[0].facility
        }
      }
      if (refs.areaListRef !== undefined) {
        vm.$refs.areaListRef.kendoWidget().setDataSource(vm.areaMap[vm.selectedFacility])
        vm.selectedArea = vm.loginUserData.area
        if (vm.loginUserData.area === null) {
          vm.selectedArea = vm.areaMap[vm.selectedFacility][0].area
        }
      }
      if (refs.lockerIdRef !== undefined) {
        vm.$refs.lockerIdRef.kendoWidget().setDataSource(vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`])
        vm.selectedLocker = vm.lockerMap[`${vm.selectedFacility}${vm.selectedArea}`][0].lockerId
      }
      vm.getLockerInfo()
    },

    onClickDetail(task){
      const vm = this
      const sendId = task.sendId
      if(EtnersCommonUtil.isNotEmpty(sendId)){
        vm.$router.push({
          name: 'SendDetail',
          params: {
            sendId : sendId
          }
        })
      }
      const receiveId = task.receiveId
      if(EtnersCommonUtil.isNotEmpty(receiveId)){
        vm.$router.push({
          name: 'ReceiveDetail',
          params: {
            receiveId : receiveId
          }
        })
      }
    },

    // 새로고침
    onClickRefresh(data) {
      const vm = this
      vm.lastRenderingTime = EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(
          new Date()
      );
      vm.$emit('refreshAll', true)
    },
  },
  data: function () {
    const now = new Date()
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    return {
      autoRender: false,
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      lastRenderingTime: EtnersParseUtil.convertDateToStringYYYYMMDDHHMISSFormat(now),
      lockerIdList: [],
      tableList: [],
      cellList: [],
      taskList: [],
      prevCell: '',
      mailBox: {},
      showBtn: false,
      isSU: isSU,
      // 검색조건
      facilityList: [],
      areaMap: {},
      lockerMap: {},
      selectedFacility: '',
      selectedArea: '',
      selectedLocker: '',
    }
  }
}

</script>
<style scoped>
.box_inventory_status_cound{
  padding: 20px;
}
.box_inventory_status_cound ul{
  display: flex;
  justify-content: space-between;
}
.box_inventory_status_cound li{
  float:left;
  width: 17%;
  padding-right: 3%;
  border-right:1px solid #e0e0e0;
  text-align: right;
  height:100%;
  /* min-height: 80px; */
}
.box_inventory_status_cound li:first-child{
  text-align: left;
  padding: 0;
  width: 200px;
  padding-left: 2%;
}
.box_inventory_status_cound li:last-child{
  border: none;
}
.box_inventory_status_cound .title{
  border:1px solid #e2e2e2;
  background: #f0f0f0;
  padding: 0px 5px;
  display: inline-block;
  border-radius: 5px;
  font-size: 9px;
  letter-spacing: 0px;
  color: #555;
}
.box_inventory_status_cound .txt_info{
  font-weight: 500;
  color:#333;
  font-size: 15px;
  margin-top: 5px;
}
.box_inventory_status_cound .txt_count{
  font-size:15px;
  color:#6e6e6e;
}
.box_inventory_status_cound .big_num{
  font-weight: 600;
  font-size: 30px;
  color:#1592e6
}
.box_inventory_status_cound .big_num::after{
  content: "/";
  padding: 0 5px;
  font-size:15px;
}
.box_inventory_status_cound .title{
  font-size: 15px;
}
.keep_info{
  margin-top: 10px;
  overflow: hidden;
  overflow-y: scroll;
  /* min-height: 515px; */
  height: 545px;
}
.keep_info li{
  /* min-height: 150px; */
  border:1px solid #e0e0e0;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  cursor: pointer;
  /* width: 48%;
  margin-right:1%;
  float: left; */
}
.keep_info li:active{
  /*box-shadow: ;*/
  background: #f5f7fb;
}
.keep_info li .left{
  float: left;
  top: 0;
  bottom: 0;
  color:#fff;
  width:30%;
  padding: 2%;
  height: 100%
}
.keep_info li .left div{
  color:#fff;
}
.keep_info li .left div:nth-child(1){
  float: right;
}
.keep_info li .left div:nth-child(2){
  font-size: 20px;
  font-weight: 500;
}
.keep_info li .left div:nth-child(3){
  font-weight: 500;
}
.keep_info li .left .txt_day{
  border:1px solid #fff;
  box-sizing: border-box;
  padding: 0px 5px ;
  font-size: 0.8em;
  margin-left:5px
}
.keep_info li dl{
  margin-left:34%;
  top:0;
  color:#333;
  padding: 2%;
}
.keep_info li dl dt{
  float: left;
  width:30%;
  line-height: 23px;
}
.keep_info li dl dd{
  margin-left:30%;
  margin-top: inherit;
  line-height: 23px;
  font-weight: 500;
}
.keep_info li dl dd:after {
  content: "";
  display: inline-block;
  clear: both;
}
.color_info > div span{
  width: 40px;
  height: 20px;
  display: block;
}
.box_available{
  background: rgb(21, 146, 230);
}
.box_use{
  background:rgb(178, 178, 178);
}
.box_select{
  background: rgb(254, 95, 64);
}
#locker .kiosk_send{
  /* border-top:10px solid #5bc988 !important; */
  box-sizing: border-box;
  background-image: linear-gradient(to right ,#5bc988 50px,#b2b2b2 50px) !important;
}
#locker .kiosk_receipt{
  /* border-top:10px solid #876fe8  !important; */
  box-sizing: border-box;
  background-image: linear-gradient(to right ,#876fe8  50px,#b2b2b2 50px) !important;
}
.color_info div span{
  float: left;
  margin-right: 5px;
  border-radius: 5px;
}
table{
  border-collapse: collapse;
  /* width: 100%;
  height: 100%; */
  position: absolute;
}
td{
  border: 1px solid #f5f7fb;
  padding: 1% 0 0 1%;
  border-radius: 10px;
  margin: 1%;
  color: #fff;
  font-size: 1.3em;
  vertical-align: top;
  cursor: pointer;
}
td::after{
  margin:1%;
}
tr {
  height: 0.6rem;
}
.cmdp_admin .gnb_pdt .box_flex > div:nth-child(2) {
  min-height: 550px;
}
#locker {
    min-height: 420px;
}
.img_noproduct{
  width: 150px !important;
  margin: 10% auto;
  display: block;
}
.quantity{
    background: #7d7d7d;
    color: #ffffff;
    border-radius: 5px;
    padding: 5px 12px;
    /* float: right; */
    margin-right: 10px;
    display: inline-block;
}
</style>
